/**
 * Created by Carsten Bühler
 * User: CBuehler on 19.02.2016
 * Copyright: xdot GmbH 2015
 */

'use strict';

import React from 'external/react';
import { Col, Container, Row } from 'external/react-bootstrap';
import { AppContext, DataLinkContainer, PortletComponent, ScrollableDataList } from 'plugin/liferay-widgets-react-web';


import JournalActions from '../actions/JournalActions';
import JournalListItem from '../components/JournalListItem';

import { getJournalStore } from '../stores/StoreFactory';
import { JournalFilters } from '../components/JournalFilters';

const JournalListC = DataLinkContainer.link(ScrollableDataList, ['list'], getJournalStore(AppContext));

class JournalListWidget extends PortletComponent {

    constructor(props){
        super(props);

        this.DATA = {
            JOURNAL_ENTRIES: this.withCtx('JournalEntries')
        };

        this.LOCAL_CONFIG = this.withCtx('Fliwas_Journal_List_Widget_Category_Keys_' + this.props.scopeGroupId + '_' + this.props.plid + '_' + this.props.portletId);

        this._asyncOpt = this._asyncOpt.bind(this);
    }

    componentDidMount(){
        const localConfig = JSON.parse(localStorage.getItem(this.LOCAL_CONFIG));
        const categoryKeys = localConfig && localConfig.properties && localConfig.properties.categoryKeys || '';
        JournalActions.search(this.DATA.JOURNAL_ENTRIES, {
            categoryKeys: categoryKeys && categoryKeys.length > 0 ? categoryKeys : [],
            start: 0,
            end: AppContext.DEFAULT_LIST_SIZE
        });
    }

    moreJournalEntries(query){
        JournalActions.moreItems(this.DATA.JOURNAL_ENTRIES, query);
    }

    renderPortlet(){

        return (
            <Container fluid>
                <Row>
                    <Col xs={12} lg={4} xl={2}>
                        <JournalFilters
                            localConfigKey={this.LOCAL_CONFIG}
                            listName={this.DATA.JOURNAL_ENTRIES}
                        />
                    </Col>
                    <Col xs={12} lg={8} xl={10}>
                        <JournalListC
                            style={{ height: 'calc(100vh - 120px)'}}
                            list={this.DATA.JOURNAL_ENTRIES}
                            ListItem={JournalListItem}
                            onClickMore={this.moreJournalEntries.bind(this)}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }

    isConfigurationNeeded(){
        return false;
    }
}

export default JournalListWidget;



// WEBPACK FOOTER //
// ./js/widgets/JournalListWidget.jsx